import React from 'react';
import AgencyAffiliates from './AgencyAffiliates';

function AgencyIndex(props) {
    return <AgencyAffiliates/>
}

export default AgencyIndex;
